import { render, staticRenderFns } from "./ResourceInfo.vue?vue&type=template&id=de13e39e&scoped=true&"
import script from "./ResourceInfo.vue?vue&type=script&lang=js&"
export * from "./ResourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ResourceInfo.vue?vue&type=style&index=0&id=de13e39e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de13e39e",
  null
  
)

export default component.exports